export class Footer
{
	footer = document.querySelector("footer")
	container = document.querySelector("footer > *")

	change()
	{
        this.footer.style.height = this.container.offsetHeight+"px"
	}

	watch()
	{
        document.addEventListener("load", () => {
            this.change()
        })
        document.addEventListener("scroll", () => {
            this.change()
        })
        document.addEventListener("resize", () => {
            this.change()
        })
	}
}
